import {Component, Input, OnInit} from '@angular/core';
import {CCPXDEVEVHI_HP} from "../complexDevices";

@Component({
  selector: 'app-cpxdev-evhi-lp',
  templateUrl: './cpxdevevhi-lp.component.html',
  styleUrls: ['./cpxdevevhi-lp.component.css']
})
export class CPXDEV_EVHI_LPComponent implements OnInit {
  @Input()  cCPXDEV_EVHI: CCPXDEVEVHI_HP | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
